import React, { useContext } from 'react';
import CountdownTimer from './CountdownTimer';
import { Store } from '../../App';
import {getUserTimeZone, convertUtcToLocal} from '../../Utils/TimeZoneUtils';

function TestTimer() {
    const { data } = useContext(Store);
    const userTimeZone = getUserTimeZone();

    // Convert UTC end time to local Date object
    let targetDate = data && convertUtcToLocal(data.endDateTime, userTimeZone);

    return (
        <CountdownTimer targetDate={targetDate} testId={data.assessmentId} />
    )
}

export default TestTimer